var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8618 7.64629L11.9715 7.99715H12.3391H18.4921L13.4917 11.7464L13.209 11.9583L13.3144 12.2956L15.2785 18.5798L10.3086 14.6039L9.99621 14.354L9.68386 14.6039L4.71392 18.5798L6.67801 12.2956L6.78341 11.9583L6.50072 11.7464L1.50034 7.99715H7.65334H8.02094L8.13058 7.64629L9.99621 1.6763L11.8618 7.64629Z",
    stroke: "#094E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlined);
export default __webpack_public_path__ + "static/media/StarOutlined.f39657e43395c49fc6a8bee0b455a334.svg";
export { ForwardRef as ReactComponent };